
import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { User } from 'firebase/auth';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

interface ProfitMarginCalculatorProps {
  currentUser: User | null;
}

const ProfitMarginCalculator: React.FC<ProfitMarginCalculatorProps> = ({ currentUser }) => {
  const [cost, setCost] = useState<number | string>('');
  const [revenue, setRevenue] = useState<number | string>('');
  const [margin, setMargin] = useState<number | null>(null);

  const calculateMargin = () => {
    const costPrice = Number(cost);
    const sellingPrice = Number(revenue);

    if (sellingPrice > 0 && costPrice > 0) {
      const profit = sellingPrice - costPrice;
      const marginValue = (profit / sellingPrice) * 100;
      setMargin(marginValue);
    } else {
      setMargin(null);
    }
  };

  return (
    <div>
      <h3 className="mb-3">Profit Margin Calculator</h3>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Cost Price</Form.Label>
          <Form.Control
            type="number"
            value={cost}
            onChange={(e) => setCost(e.target.value)}
            placeholder="Enter cost price"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Selling Price</Form.Label>
          <Form.Control
            type="number"
            value={revenue}
            onChange={(e) => setRevenue(e.target.value)}
            placeholder="Enter selling price"
          />
        </Form.Group>
        <Button variant="primary" onClick={calculateMargin}>
          Calculate Margin
        </Button>
        {currentUser && margin !== null && (
          <Button variant="secondary" onClick={async () => {
            try {
              await addDoc(collection(db, `users/${currentUser.uid}/savedCalculations`), {
                calculatorType: 'profitMargin',
                cost,
                revenue,
                margin,
                timestamp: new Date(),
              });
              alert('Profit Margin calculation saved!');
            } catch (e) {
              console.error('Error saving document: ', e);
              alert('Error saving calculation.');
            }
          }} className="ms-2">
            Save Calculation
          </Button>
        )}
      </Form>
      {margin !== null && (
        <Alert variant="success" className="mt-4">
          <h5>Profit Margin: {margin.toFixed(2)}%</h5>
        </Alert>
      )}
    </div>
  );
};

export default ProfitMarginCalculator;
